/*
 * @Descripttion:
 * @version:
 * @Author: wlk
 * @Date: 2023-11-30 09:33:00
 * @LastEditors: wlk
 * @LastEditTime: 2024-07-03 13:33:12
 */
import { defineStore } from "pinia";
import ajaxAuthService from "@/service/api/auth.ts";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: "",
    userInfo: {} as any,
    userLevel: "",
    isLoggedIn: false,
    menuList: [
      {
        name: "首页",
        icon: "home",
        id: 1,
        path: "/dataDashboard",
      },
      {
        name: "订单管理",
        icon: "setting",
        id: 4,
        childs: [
          {
            name: '业务员综合账单',
            id: 41,
            parentId: 4,
            path: '/order/orderList'
          }
        ]
      },
      {
        name: "设置",
        icon: "setting",
        id: 8,
        childs: [
          {
            name: "个人信息",
            id: 81,
            parentId: 8,
            path: "/setting/personalInfo"
          },
          {
            name: "修改密码",
            id: 82,
            parentId: 8,
            path: "/setting/resetPassword"
          }
        ]
      }
    ],
    orderInfo: {} as any,
    quickPrintOrderInfo: {} as any
  }),
  getters: {
    getMenusList: (state) => state.menuList,
    getUserLevel: (state) => state.userLevel,
    getOrderInfo: (state) => state.orderInfo,
    getUserInfo: (state) => state.userInfo,
    getQuickPrintOrderInfo: (state) => state.quickPrintOrderInfo
  },
  actions: {
    //登录
    login(params: any) {
      return new Promise((resolve, reject) => {
        ajaxAuthService
          .login(params)
          .then((res) => {
            if (res.code === 1) {
              this.token = res.data;
              localStorage.setItem("token", res.data);
              this.isLoggedIn = true;
              this.getUserInfoFun();
            }
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    },
    async getUserInfoFun() {
      const res = await ajaxAuthService.getUserInfo();
      this.userInfo = res.data;
      localStorage.setItem("userInfo", JSON.stringify(res.data));
    },
    //退出登录
    logOut() {
      return new Promise((resolve, reject) => {
        ajaxAuthService
          .logOut()
          .then((res) => {
            console.log(res);
            if (res.code === 1) {
              this.token = "";
              // localStorage.clear()
              // sessionStorage.clear()

              // 定义要删除的键数组
              const keysToRemove = ['token', 'auth', 'sysSetting', 'tabs', 'userInfo'];
              keysToRemove.forEach(key => {
                localStorage.removeItem(key);
              });
            }
            resolve(res);
          })
          .catch((err) => reject(err));
      });
    },
    /** 存储订单信息 */
    setOrderInfo(value: any) {
      this.orderInfo = value;
    },
    /** 存储快速打印订单信息 */
    setQuickPrintOrderInfo(value: any) {
      this.quickPrintOrderInfo = value;
    },
    /** 存储用户信息 */
    setUserInfo(value: any) {
      this.userInfo = value;
    }
  },
  persist: {
    storage: localStorage
  }
});
